import { globalURL, fetchApiHeaders } from "../../app/constants/constants";
import { checkFormFields } from "../../app/helpers/functions";

const toggleModal = (show, process) => dispatch => {
    dispatch({
        type: "TOGGLE_BANNER_MODAL",
        payload: {
            show: show,
            process: process
        }
    })

    if (!show) {
        dispatch({
            type: "SET_TABLE_ROW_DATA",
            payload: {
                row: null,
                rowIndex: 0
            }
        })
    }
}


const setValue = (key, value, banners) => dispatch => {
    if (key === "order") {
        if (Number(value) > banners.length) {
            dispatch({
                type: "SET_VALUE_ERROR_BANNER",
                payload: {
                    key: key,
                    value: Number(value),
                    helpertext: "Sıra numarası maksimum " + banners.length + " olabilir."
                }
            })
        } else {
            if (Number(value) === 0) {
                dispatch({
                    type: "SET_VALUE_BANNER",
                    payload: {
                        key: key,
                        value: value
                    }
                })
                dispatch({
                    type: "SET_VALUE_ERROR_BANNER",
                    payload: {
                        key: key,
                        value: value,
                        helpertext: "Lütfen 0 dan büyük bir değer giriniz."
                    }
                })
            } else {
                dispatch({
                    type: "SET_VALUE_BANNER",
                    payload: {
                        key: key,
                        value: Number(value)
                    }
                })
            }
        }
    } else {
        dispatch({
            type: "SET_VALUE_BANNER",
            payload: {
                key: key,
                value: value
            }
        })
    }
}

const getAll = (token) => dispatch => {
    dispatch({
        type: "GET_ALL_BANNERS"
    })
    fetch(globalURL + "/banner/getAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        }
    })
        .then((result) => result.json())
        .then(async (banners) => {
            if (banners.success) {
                dispatch({
                    type: "FETCH_ALL_BANNERS",
                    payload: banners.data
                })
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });

                dispatch({
                    type: "ERROR_ALL_BANNERS",
                    payload: banners
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });

            dispatch({
                type: "ERROR_ALL_BANNERS",
                payload: error
            });
        })
}

const tableActions = (process, id, token) => dispatch => {
    if (process === "update") {
        dispatch({
            type: "GET_DETAIL_BANNER"
        })
        fetch(globalURL + "/banner/getDetail", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                id: id
            })
        })
            .then((result) => result.json())
            .then(async (detail) => {
                if (detail.success) {
                    dispatch({
                        type: "FETCH_DETAIL_BANNER",
                        payload: detail
                    })
                    dispatch({
                        type: "TOGGLE_BANNER_MODAL",
                        payload: {
                            show: true,
                            process: process
                        }
                    })
                } else {
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: "İşlem gerçekleştirilirken bir hata oluştu.",
                            type: "error"
                        }
                    });

                    dispatch({
                        type: "ERROR_DETAIL_BANNER",
                        payload: detail
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_DETAIL_BANNER",
                    payload: error
                })
            })
    } else {
        dispatch({
            type: "TOGGLE_BANNER_MODAL",
            payload: {
                show: true,
                process: process
            }
        })
    }
}

const update = (token, id, data, rowIndex) => dispatch => {
    dispatch({
        type: "GET_UPDATE_BANNER"
    });

    var checkForm = checkFormFields(data, true);
    if (!checkForm.result) {
        // update
        fetch(globalURL + "/banner/update", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                id: id,
                title: {
                    tr: data[0].value,
                    eng: data[5].value
                },
                description: {
                    tr: data[1].value,
                    eng: data[6].value
                },
                isActive: data[2].value,
                image: data[3].value,
                order: data[4].value,
                text: {
                    tr: data[7].value,
                    eng: data[8].value
                }
            })
        })
            .then((result) => result.json())
            .then(async (update) => {
                if (update.success) {
                    dispatch({
                        type: "FETCH_UPDATE_BANNER",
                        payload: update,
                        rowIndex: rowIndex
                    });
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: data[0].value + " banner başarıyla güncellendi.",
                            type: "success"
                        }
                    });
                } else {
                    if (update.field) {
                        dispatch({
                            type: "SET_VALUE_ERROR_BANNER",
                            payload: {
                                key: update.field,
                                helpertext: update.errorMessage
                            }
                        })
                    } else {
                        dispatch({
                            type: "TOGGLE_APP_ALERT",
                            payload: {
                                show: true,
                                message: "İşlem gerçekleştirilirken bir hata oluştu.",
                                type: "error"
                            }
                        });
                    }
                    dispatch({
                        type: "ERROR_UPDATE_BANNER",
                        payload: update
                    })
                }
            })
            .catch((error) => {
                console.log(error)
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_UPDATE_BANNER",
                    payload: error
                })
            })

    } else {
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_BANNER",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        });

        checkForm.invalidFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_BANNER",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        });
    }
}

const deleteEntity = (token, row, rowIndex) => dispatch => {
    dispatch({
        type: "GET_DELETE_BANNER"
    })
    fetch(globalURL + "/banner/delete", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            id: row.id,
            title: row.title
        })
    })
        .then((result) => result.json())
        .then(async (deleteRecord) => {
            if (deleteRecord.success) {
                dispatch({
                    type: "FETCH_DELETE_BANNER",
                    payload: deleteRecord,
                    rowIndex: rowIndex
                })
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "Banner başarıyla silindi.",
                        type: "success"
                    }
                });
            } else {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_DELETE_BANNER",
                    payload: deleteRecord
                })
            }
        })
        .catch((error) => {
            dispatch({
                type: "TOGGLE_APP_ALERT",
                payload: {
                    show: true,
                    message: "İşlem gerçekleştirilirken bir hata oluştu.",
                    type: "error"
                }
            });
            dispatch({
                type: "ERROR_DELETE_BANNER",
                payload: error
            })
        })
}

const createNew = (token, data) => dispatch => {
    dispatch({
        type: "GET_INSERT_BANNERS"
    })

    var checkForm = checkFormFields(data, true);
    if (!checkForm.result) {
        fetch(globalURL + "/banner/create", {
            method: 'POST',
            headers: {
                ...fetchApiHeaders.POST,
                token: token
            },
            body: JSON.stringify({
                title: {
                    tr: data[0].value,
                    eng: data[4].value
                },
                description: {
                    tr: data[1].value,
                    eng: data[5].value
                },
                image: data[2].value,
                order: data[3].value,
                text: {
                    tr: data[6].value,
                    eng: data[7].value
                }
            })
        })
            .then((result) => result.json())
            .then(async (insert) => {
                if (insert.success) {
                    dispatch({
                        type: "FETCH_INSERT_BANNERS",
                        payload: insert
                    });
                    dispatch({
                        type: "TOGGLE_APP_ALERT",
                        payload: {
                            show: true,
                            message: data[0].value + " banner başarıyla oluşturuldu",
                            type: "success"
                        }
                    });
                } else {
                    if (insert.field) {
                        dispatch({
                            type: "SET_VALUE_ERROR_BANNER",
                            payload: {
                                key: insert.field,
                                helpertext: insert.errorMessage
                            }
                        })
                    } else {
                        dispatch({
                            type: "TOGGLE_APP_ALERT",
                            payload: {
                                show: true,
                                message: "İşlem gerçekleştirilirken bir hata oluştu.",
                                type: "error"
                            }
                        });
                    }

                    dispatch({
                        type: "ERROR_INSERT_BANNERS",
                        payload: insert
                    })
                }
            })
            .catch((error) => {
                dispatch({
                    type: "TOGGLE_APP_ALERT",
                    payload: {
                        show: true,
                        message: "İşlem gerçekleştirilirken bir hata oluştu.",
                        type: "error"
                    }
                });
                dispatch({
                    type: "ERROR_INSERT_BANNERS",
                    payload: error
                })
            })
    } else {
        checkForm.nullFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_BANNER",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        });

        checkForm.invalidFields.map((item, index) => {
            return dispatch({
                type: "SET_VALUE_ERROR_BANNER",
                payload: {
                    ...item,
                    helpertext: item.helperText
                }
            })
        });
    }
}

export {
    toggleModal,
    setValue,
    getAll,
    createNew,
    tableActions,
    update,
    deleteEntity
}